import { postCrossAppDndWatchMoveJobToChildIframes } from '@inno-tools/container-bridge'
import { useMutation } from '@tanstack/react-query'

import { filesApi } from '../filesApi'

type MoveItemsToFolderParams = {
  destinationFolderId: number
  sourceItemIds: number[]
}

type MoveItemsResponse = {
  data: {
    job_id?: string
    total_items?: number
  }
}

export const useMoveItemsToFolderMutation = () => {
  // Deliberately no files-list invalidation: /items/move is async, so callers
  // wait for the job-completed socket event before refetching.
  return useMutation({
    mutationFn: async ({
      destinationFolderId,
      sourceItemIds
    }: MoveItemsToFolderParams) => {
      const { data } = await filesApi.post<MoveItemsResponse>('/items/move', {
        destination_item_id: destinationFolderId,
        source_item_ids: sourceItemIds
      })
      const jobId = data.data.job_id
      const totalItems =
        typeof data.data.total_items === 'number'
          ? data.data.total_items
          : sourceItemIds.length
      if (jobId) {
        postCrossAppDndWatchMoveJobToChildIframes({ jobId, totalItems })
      }
      return { jobId, totalItems }
    }
  })
}
